import TabFilter from "../shared/TabFilter";

const TABS = ["all", "pending", "active", "completed", "deleted"];

type FreeSubscriptionTabsProps = {
  selectedTab: string;
  onSelect: (tab: string) => void;
};

const FreeSubscriptionTabs: React.FC<FreeSubscriptionTabsProps> = ({
  selectedTab,
  onSelect,
}) => {
  return (
    <TabFilter tabs={TABS} selectedTab={selectedTab} onSelect={onSelect} />
  );
};

export default FreeSubscriptionTabs;
